import React from 'react';
import PayoutMgmt from '../../screens/PayoutMgmt';

const PayoutAdminMgmt = () => {
    return <PayoutMgmt />
}

export default PayoutAdminMgmt;